import { Control } from '@fiverr-private/forms';

export default Control;
